import {createRequest, makeRequest, prepareRequest} from "../utils/apiUtil";

export function getAll(filters = {}, includes = [], extraParams = {}) {
    return makeRequest(createRequest('business'), prepareRequest(filters, includes, extraParams));
}

export function findBySubdomain(subdomain, includes = []) {
    return getAll({subdomain}, includes)
}